import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import wechatIndex from '@/wechat/index'
import wechatHome from '@/wechat/home'
import wechatPoint from '@/wechat/point'
import wechatStock from '@/wechat/stock'
import wechatJcjt from '@/wechat/jcjt'
import wechatDf from '@/wechat/df'
import wechatDfdetail from '@/wechat/dfdetail'
import wechatjcjtdetail from '@/wechat/jcjtdetail'
import wechatmy from '@/wechat/my'
import wechatgiftlogin from '@/wechat/giftlogin'
import wechatgiftinfo from '@/wechat/giftinfo'
import wechatgiftorder from '@/wechat/giftorder'
import wechatgiftorderdetail from '@/wechat/giftorderdetail'
import wechatgiftbirth from '@/wechat/giftbirth'
import wechatgiftcamp from '@/wechat/giftcamp'
import wechatsyspay from '@/wechat/syspay'

Vue.use(Router)

export default new Router({
  mode:"history",//history or hash
  routes: [
    {
      path: '/',
      name: 'wechatIndex',
      component: wechatIndex
    },
    {
      path: '/wechat/home',
      name: 'wechatHome',
      component: wechatHome
    },
    {
      path: '/wechat/point',
      name: 'wechatPoint',
      component: wechatPoint
    },
    {
      path: '/wechat/stock',
      name: 'wechatStock',
      component: wechatStock
    },
    {
      path: '/wechat/jcjt',
      name: 'wechatJcjt',
      component: wechatJcjt
    },
    {
      path: '/wechat/df',
      name: 'wechatDf',
      component: wechatDf
    },
    {
      path: '/wechat/dfdetail',
      name: 'wechatDfdetail',
      component: wechatDfdetail
    },
    {
      path: '/wechat/jcjtdetail',
      name: 'wechatjcjtdetail',
      component: wechatjcjtdetail
    },
    {
      path: '/wechat/my',
      name: 'wechatmy',
      component: wechatmy
    },
    {
      path: '/wechat/giftlogin',
      name: 'wechatgiftlogin',
      component: wechatgiftlogin
    },
    {
      path: '/wechat/giftinfo',
      name: 'wechatgiftinfo',
      component: wechatgiftinfo
    },
    {
      path: '/wechat/giftorder',
      name: 'wechatgiftorder',
      component: wechatgiftorder
    },
    {
      path: '/wechat/giftorder',
      name: 'wechatgiftorder',
      component: wechatgiftorder
    },
    {
      path: '/wechat/giftorderdetail',
      name: 'wechatgiftorderdetail',
      component: wechatgiftorderdetail
    },
    {
      path: '/wechat/giftbirth',
      name: 'wechatgiftbirth',
      component: wechatgiftbirth
    },
    {
      path: '/wechat/giftcamp',
      name: 'wechatgiftcamp',
      component: wechatgiftcamp
    },
    {
      path: '/syspay',
      name: 'wechatsyspay',
      component: wechatsyspay
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js